import type { Period } from "@common/components/filters/period-model"

export const AIRCRAFT_LIMIT = 1000
export const CUSTOMER_LIMIT = 1000

export type FilterValues = {
  aircraft?: string[]
  customer?: string[]
  period?: Period
  from?: string
  to?: string
}
